export default {
  bodyParams: {
    addParam: 'Add parameters',
    name: 'Parameter name',
    type: 'Parameter type',
    example: 'example',
    desc: 'Description',
    addTitle: 'Add parameters',
    namePlaceholder: 'Please enter the parameter name',
    typePlaceholder: 'Please select parameter type',
    examplePlaceholder: 'Please enter an example',
    descPlaceholder: 'Please enter parameter description',
    cancel: 'cancel',
    ok: 'confirm',
    errorInfo: 'Incorrect format'
  },
  editAreaText: {
    format: 'format',
    copy: 'copy',
    maxLengthTip: 'The sample length cannot exceed',
    formatError: 'Format failed! The data cannot be parsed',
    formatSuccess: 'format successful',
    copySuccess: 'copy successful',
  },
  requestDataBox: {
    title: 'Body type:',
    addData: 'Add data',
    name: 'Parameter name',
    position: 'Parameter position',
    type: 'Parameter type',
    required: 'required',
    yes: 'Yes',
    no: 'No',
    example: 'example',
    desc: 'description',
    addTitle: 'Add parameters',
    namePlaceholder: 'Please enter the parameter name',
    positionPlaceholder: 'Please select the parameter position',
    typePlaceholder: 'Please select parameter type',
    requiredPlaceholder: 'Please select whether it is required',
    examplePlaceholder: 'Please enter an example',
    descPlaceholder: 'Please enter parameter description',
    cancel: 'cancel',
    ok: 'confirm'
  },
  configDist: {
    addData: 'Add data',
    notBlack: 'The input content cannot be empty',
    isDeleteContent: 'Do you want to delete this piece of data? ',
  },
  dictionariesTable: {
    string: 'string',
    file: 'file',
    parameterName: 'Dictionary',
    parameterCloumn: 'English'
  },
  dictionariesTree: {
    placeholder: 'Please enter content',
    allType: 'All categories',
    deleteContent: 'This operation will permanently delete the file, do you want to continue?',
  },
  eleHead: {
    loginOut: 'Exit',
    tipContent: 'Please note that this operation will exit the system',
    tipTitle: 'Friendly reminder',
    loginOutMsg: 'Exit system successfully'
  },
  requestSelect: {
    networkError: 'Request failed,',
    refresh: 'Click to refresh',
    loading: 'loading...',
  },
  titleTable: {
    pushRecord: 'Push record',
    upgradeRecord: 'Push record',
  },
}


// WEBPACK FOOTER //
// ./src/components/components.en.js